import { Component, Inject, Input } from '@angular/core';

import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';

@Component({
    selector: 'rwidget-email-sent',
    templateUrl: './email-sent.component.html',
    styleUrls: ['./email-sent.component.scss'],
})
export class EmailSentComponent {
    @Input() email = '';
    @Input() formerCustomerFirstVisit = false;
    @Input() title = 'RECOVER_SENT_VALIDATION_MAIL';
    @Input() description = 'RECOVER_VALIDATION_MAIL_DESCRIPTION';
    @Input() firstVisitTitle = 'FORMER_CUSTOMER_RECOVER_SENT_VALIDATION_MAIL';
    @Input() firstVisitDescription = 'FORMER_CUSTOMER_RECOVER_VALIDATION_MAIL_DESCRIPTION';

    themeFeature = ThemeFeature;

    constructor(
        @Inject('ENV') public env: any,
    ) {}
}
